import "./App.css";
import RoutesDefinitions from "./routes/RoutesDefinitions";
import { createTheme, ThemeProvider } from "@mui/material";
import { persistor, store } from "./store/store";
import { Provider } from "react-redux";
import "./resources/scss/main.scss";
import { PersistGate } from "redux-persist/integration/react";
import Header, { BackgroundBox } from "./components/header/Header";
import React from "react";
import FloralBg from "./resources/images/svg/FloralPage@1,5x.svg";
import "./prototypes";
import Cookies from "universal-cookie";
require("moment/locale/fr");

function App() {
	const theme = createTheme({
		shadows: [
			"none",
			"0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
			"0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
			"0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
			"0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
			"0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
			"0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
			"0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
			"0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
			"0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
			"0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
			"0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
			"0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
			"0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
			"0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
			"0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
			"0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
			"0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
			"0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
			"0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
			"0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
			"0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
			"0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
			"0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
			"0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
			"5px 0 40px lightgrey;",
		],
		typography: {
			fontFamily: [
				"branding",
				"Branding SemiBold",
				"-apple-system",
				"BlinkMacSystemFont",
				"Segoe UI",
				"Roboto",
				"Helvetica Neue",
				"Arial",
				"sans-serif",
				"Apple Color Emoji",
				"Segoe UI Emoji",
				"Segoe UI Symbol",
			].join(","),
		},
		palette: {
			primary: {
				main: "#8F6C9F",
			},
			secondary: {
				main: "#182B43",
				warning: "#F07892",
			},
			text: {
				primary: "#182B43",
				secondary: "#182B43",
			},
			lightRed: "#EF7D8F",
			live: "#FF4626",
		},
		shape: {
			borderRadius: 0,
		},
	});

	const queryParameters = new URLSearchParams(window.location.search);

	const setCookie = (cookieValue) => {
		const cookies = new Cookies();
		cookies.set(cookieValue.name, cookieValue.valeur, {
			path: "/",
			domain: ".inexplore.com",
			expires: new Date(Date.now() + cookieValue.duree),
		});
	};

	React.useEffect(() => {
		const affiliation = queryParameters.get("affiliation");
		const tracking = queryParameters.get("tracking");
		if (affiliation) setCookie({ name: "affiliation", valeur: affiliation, duree: 2678400000 });
		if (tracking) setCookie({ name: "tracking", valeur: tracking, duree: 267840000 });
	}, [queryParameters]);

	return (
		<div
			className="App"
			style={{
				width: "100%",
				height: "100%",
				background: "linear-gradient(90deg, #162941 0%, #8F6C9F 100%)",
			}}
		>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<ThemeProvider theme={theme}>
						{/*<InvoiceHeader/>*/}
						{/*<div style={{position: 'relative'}}>*/}
						<RoutesDefinitions />
						{/*<Footer/>*/}
						{/*</div>*/}
					</ThemeProvider>
				</PersistGate>
			</Provider>
		</div>
	);
}

export default App;
